import React, { Component } from "react";
import Error from "./components/Error/Error";
import Home from "./containers/Home/Home";
import Layout from "./hoc/Layout/Layout";
import { Switch, Route } from "react-router-dom";
import ProjectBox from "./components/ProjectBox/ProjectBox";
import Pgp from "./containers/Pgp/Pgp";

class App extends Component {
  render() {
    return (
      <>
        <Layout>
          <Switch>
            <Route exact path="/" component={Home} />
            <Route path="/projects" component={ProjectBox} />
            <Route path="/pgp" component={Pgp} />
          </Switch>
        </Layout>
      </>
    );
  }
}

export default App;
